<template>
  <div>
    <div class="onboarding-dashboard-models-step">
      <h1 class="onboarding-dashboard-models-step__message">
        {{ $t('components.Onboarding.label.title.dashboardModelsMessage') }}
      </h1>
      <p class="onboarding-dashboard-models-step__empty-dashboard-message">
        {{ $t('components.Onboarding.label.title.emptyDashboardMessage') }}
      </p>
      <div>
        <Tabs
          :list-items="dashboardModels"
          @selected-index="toggleDashboard"
        />
      </div>
      <OnboardingDashboardInfos :dashboard-models="dashboardModels[dashboardSelected]" />
    </div>
  </div>
</template>

<script>
import { DASHBOARD_MODELS } from '@/utils/constants';
import OnboardingDashboardInfos from '@/components/onboarding/OnboardingDashboardInfos';

import Tabs from '@/components/onboarding/Tabs.vue';

export default {
  name: 'OnboardingDashboardModelsStep',
  components: {
    OnboardingDashboardInfos,
    Tabs,
  },
  props: {
    onboardingData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dashboardModels: DASHBOARD_MODELS,
      dashboardSelected: 0,
    };
  },
  mounted() {
    this.setDashboardSelected();
    this.setDashboardIdSelected();
  },
  methods: {
    setDashboardSelected() {
      this.onboardingData.templateType = this.dashboardModels[this.dashboardSelected].title;
    },
    setDashboardIdSelected() {
      this.onboardingData.choosenDashboard = this.dashboardModels[this.dashboardSelected].id;
    },
    toggleDashboard(value) {
      this.dashboardSelected = value;
      this.setDashboardSelected();
      this.setDashboardIdSelected();
    },
  },
};
</script>

<style lang="scss" scoped>

  .onboarding-dashboard-models-step {
    $st-message-color: #000;

    &__message {
      color: $st-message-color;
      font-weight: var(--ds-font-weight-semibold);
      font-size: var(--ds-font-size-xl);
      line-height: var(--ds-font-line-height-normal);
    }

    &__empty-dashboard-message {
      color: var(--ds-color-text-2);
      margin-top: var(--ds-spacing-inline-nano);
      margin-bottom: var(--ds-spacing-inline-sm);
      font-weight: var(--ds-font-weight-regular);
      font-size: var(--ds-font-size-baseline);
      line-height: var(--ds-font-line-height-normal);
    }
  }

</style>
